import {useParams, useSearchParams} from "react-router-dom";
import styled, {keyframes} from "styled-components";
import {Column} from "../../styles/common";
import {useEffect, useState} from "react";
import {UrlRepository} from "../../core/repository";
import {Red} from "../../styles/colors";
import {Text} from "../../styles/font";

const Container = styled(Column)`
  max-width: calc(var(--vw, 1vw) * 100);
  height: 100%;
  padding: spacing(1.5);
  justify-content: center;
  align-items: center;
`;

const rotation = keyframes`
  to {
    transform: rotate(-1turn);
  }
`;

const GlobalLoaderSpinner = styled.div`
  height: 200px;
  aspect-ratio: 1;
  background: radial-gradient(closest-side, #3643ba 94%, transparent) top/3px
      3px no-repeat,
    conic-gradient(#3643ba 30%, transparent 80%);
  border-radius: 50%;
  -webkit-mask-image: radial-gradient(closest-side, transparent 197px, #000 0);
  mask-image: radial-gradient(closest-side, transparent 197px, #000 0);
  animation: ${rotation} 1s linear infinite;
`;

const ErrorMessage = styled(Text)`
  color: ${Red};
`;

const HomePage = () => {
  const {code} = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    redirect();
  }, [code, searchParams]);

  const redirect = async () => {
    if (code) {
      const result = await UrlRepository.getUrl(
        code,
        searchParams.get("q") || undefined,
        searchParams.get("s") || undefined,
        searchParams.get("m") || undefined
      );
      if (result) {
        window.location.replace(result);
      } else {
        setError(true);
      }
    }
  };

  return (
    <Container>
      {error ? (
        <ErrorMessage>This link is not authorized</ErrorMessage>
      ) : (
        <GlobalLoaderSpinner />
      )}
    </Container>
  );
};

export default HomePage;
